<bdeo-drawer #drawer closable overlay [headerTitle]="'brokers:edit_price.title' | i18nextEager">
  <form [formGroup]="priceForm" class="form">
    <div class="form__inner-wrapper">
      <div class="form__group">
        <div class="form__group-inner-wrapper">
          <bdeo-input
            [error]="!paintHourPrice.valid && !paintHourPrice.pristine"
            required
            formControlName="paintHourPrice"
            size="medium"
            inputSize="80"
            type="form"
            variant="number"
            placeholder="0.00"
            min="0"
            label="{{ 'brokers:edit_price.paint_price_per_hours_label' | i18nextEager }}"
            value=""
            ngDefaultControl
          >
            <span slot="suffix" class="form__group-currency">{{ currency }}/h</span>
            @if (!paintHourPrice.valid && !paintHourPrice.pristine) {
              <span slot="help-text">
                {{ 'brokers:edit_price.paint_price_per_hours_help' | i18nextEager }}
              </span>
            }
          </bdeo-input>
          <span class="form__mobile-controls">
            <bdeo-button
              data-test-id="decrement-button-paint"
              size="large"
              type="secondary"
              icon="less-less"
              skin="outline"
              bigIcon
              [disabled]="paintHourPrice.disabled || (paintHourPrice.value && paintHourPrice.value <= 0)"
              (click)="decrement(paintHourPrice)"
            ></bdeo-button>
            <bdeo-button
              data-test-id="increment-button-paint"
              size="large"
              type="secondary"
              icon="plus-plus"
              skin="outline"
              bigIcon
              (click)="increment(paintHourPrice)"
            ></bdeo-button>
          </span>
        </div>
        <div class="form__group-inner-wrapper">
          <bdeo-input
            [error]="!labourHourPrice.valid && !labourHourPrice.pristine"
            required
            formControlName="labourHourPrice"
            size="medium"
            inputSize="80"
            type="form"
            variant="number"
            placeholder="0.00"
            min="0"
            label="{{ 'brokers:edit_price.labour_price_per_hours_label' | i18nextEager }}"
            value=""
            ngDefaultControl
          >
            <span slot="suffix" class="form__group-currency">{{ currency }}/h</span>
            @if (!labourHourPrice.valid && !labourHourPrice.pristine) {
              <span slot="help-text">
                {{ 'brokers:edit_price.labour_price_per_hours_help' | i18nextEager }}
              </span>
            }
          </bdeo-input>
          <span class="form__mobile-controls">
            <bdeo-button
              data-test-id="decrement-button-labour"
              size="large"
              type="secondary"
              icon="less-less"
              skin="outline"
              bigIcon
              [disabled]="labourHourPrice.disabled || (labourHourPrice.value && labourHourPrice.value <= 0)"
              (click)="decrement(labourHourPrice)"
            ></bdeo-button>
            <bdeo-button
              data-test-id="increment-button-labour"
              size="large"
              type="secondary"
              icon="plus-plus"
              skin="outline"
              bigIcon
              [disabled]="labourHourPrice.disabled"
              (click)="increment(labourHourPrice)"
            ></bdeo-button>
          </span>
        </div>
      </div>
    </div>
  </form>

  <app-footer selectorForPadding=".add-wrapper">
    <bdeo-button
      data-test-id="save-button"
      type="primary"
      [icon]="'check-check'"
      [text]="'brokers:edit_price.save' | i18nextEager"
      (click)="save()"
      [disabled]="!priceForm.valid || priceForm.pristine"
    ></bdeo-button>
    <bdeo-button type="secondary" [text]="'brokers:edit_price.cancel' | i18nextEager" skin="ghost" (click)="close()"></bdeo-button>
  </app-footer>
</bdeo-drawer>
